import { useSelector } from "react-redux";
import { selectAuthState } from "../sagas/auth/authSlice";
import { Role } from "@inosio/payments-sdk";

export function useInosioUser() {
  const { ipaUser } = useSelector(selectAuthState);
  const isInosioUser = !!ipaUser?.profiles.some((p) => p.role === Role.InosioAdmin || p.role === Role.InosioStaff);

  return [isInosioUser, ipaUser];
}
